import VisuallyHidden from './VisuallyHidden'

export default VisuallyHidden



// WEBPACK FOOTER //
// ./src/components/VisuallyHidden/index.js